import React from "react";
import { View, ActivityIndicator } from "react-native";
import { useFocusEffect } from "expo-router";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Colors } from "@/constants/Colors";
import useFinanceDataStore from "@/store/financeData";
import IncomeNetWorthCard from "@/components/myMoney/IncomeNetWorthCard";
import PaychecksCard from "@/components/myMoney/PaychecksCard";
import BalancesCard from "@/components/myMoney/BalancesCard";
import { SCREEN_WIDTH } from "@/constants/Sizes";
import FBTrackingService from "@/services/fbTrackingService";

export default function IncomeScreen() {
  const { financeData, isLoading } = useFinanceDataStore();

  useFocusEffect(
    React.useCallback(() => {
      FBTrackingService.trackViewContent("my-money-income");
    }, []),
  );

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={Colors.primary} />
      </View>
    );
  }

  return (
    <View style={styles.content}>
      <IncomeNetWorthCard financeData={financeData} />
      <PaychecksCard financeData={financeData} />
      <BalancesCard financeData={financeData} />
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    padding: 16,
    gap: 12,
    width: SCREEN_WIDTH,
    alignSelf: "center",
    paddingBottom: 100,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.background,
  },
});
